export { default } from './LatestSong';
